import React from "react";
import { Card, Skeleton } from "@mui/material";
import { styled, Box } from "@mui/system";

const CardRoot = styled(Card)(({ theme }) => ({
  padding: "20px 24px",
  flex: "1 1 250px",
  minHeight: 100,
  borderRadius: 12,
  display: "flex",
  flexDirection: "column",
  gap: 12,
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: "none",
}));

const CardHeader = styled(Box)(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  gap: 12,
}));

const IconWrapper = styled(Box)(({ theme }) => ({
  width: 36,
  height: 36,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255,255,255,0.08)"
      : theme.palette.grey[100],
  flexShrink: 0,
  color: theme.palette.text.primary,
}));

const TextWrapper = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  flex: 1,
}));

const CardTitle = styled("div")(() => ({
  fontSize: "1rem",
  fontWeight: 600,
  lineHeight: 1.3,
  display: "-webkit-box",
  WebkitLineClamp: 3,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
}));

const CustomSimpleCard = ({ children, title, subtitle, icon, isLoading }) => {
  return (
    <CardRoot>
      <CardHeader>
        {icon && <IconWrapper>{icon}</IconWrapper>}

        <TextWrapper>
          <CardTitle>{title}</CardTitle>
          {subtitle && <Box sx={{ mt: 0.5 }}>{subtitle}</Box>}
          {isLoading ? (
            <Box sx={{ mt: 0.5 }}>
              <Skeleton variant="text" width={60} height={32} />
            </Box>
          ) : (
            children && <Box>{children}</Box>
          )}
        </TextWrapper>
      </CardHeader>
    </CardRoot>
  );
};

export default CustomSimpleCard;
